
export class UserDTO {
    currentUser: UserInfoDTO;
    userGroups: UserGroup[];
}

export class UserInfoDTO{
    displayName: string;
    jobTitle: string;
    officeLocation: string;
    department: string;
    userPrincipalName: string;
    country: string;
}

export class UserGroup {
    displayName: string;
    id: string;
}
